module.exports = __webpack_public_path__ + "img/cooming_soon.39f57f9d.svg";